<!--
* UI Name: HTTP
* Modify Date: 2022/06/15
-->
<template>
  <v-card>
    <v-card-text>
      <v-form ref="form" lazy-validation class="px-4" style="height: 595px; overflow: auto">
        <v-row>
          <v-col cols="12" md="4" class="mt-6">
            <font class="text-base font-bold leading-snug textcolor5--text">
              {{ $t('lbl.communications.http') }} Proxy
            </font>
            <v-text-field
              v-model="formData.name"
              :rules="
                formData.name && formData.name.length > 50
                  ? ['Max 50 characters']
                  : [validationUtils.required]
              "
              placeholder="Enter the name"
              ref="name"
              :autofocus="true"
              solo
              :disabled="!$auth.manage"
              class="mt-5"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="px-4">
            <v-row>
              <v-col cols="12" md="12">
                <v-label>
                  <span class="field-label required-text">{{ $t('lbl.communications.uri') }}</span>
                </v-label>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <span>{{ resourceId }}</span>
                <v-text-field
                  v-model="path"
                  solo
                  hide-details
                  @keyup="changePath($event)"
                  @change="checkDuplicatedUri()"
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" md="2" class="pl-0">
                <v-btn
                  @click='generateURI'
                  class="btn btn-popup-search btn-window-generate"
                  color="primary"
                  :style="this.item.action == 'edit' ? 'pointer-events: none' : ''"
                  >{{ $t("btn.communications.generate") }}
                </v-btn>
              </v-col> -->
            </v-row>
            <v-row class="mb-5">
              <v-col cols="12" md="6">
                {{ $t('lbl.communications.httpRecommend') }}
              </v-col>
              <v-col cols="12" md="6">
                {{ $t('lbl.communications.httpEx') }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" class="px-4">
            <v-row>
              <v-col cols="12" md="12">
                <v-label>
                  <v-icon x-small>fas fa-asterisk</v-icon>
                  <span class="field-label required-text ml-1">{{
                    $t('lbl.communications.api')
                  }}</span>
                </v-label>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="10">
                <v-text-field
                  v-model="formData.authToken"
                  :rules="[validationUtils.required]"
                  solo
                  hide-details
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2" class="pl-0">
                <v-btn
                  @click="generateApiKey"
                  class="btn btn-popup-search btn-window-generate"
                  color="primary"
                  :style="this.item.action == 'edit' ? 'pointer-events: none' : ''"
                  >{{ $t('btn.communications.generate') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="12">
                <v-checkbox
                  label="Use JSON Schema Validation"
                  true-value="Y"
                  false-value="N"
                  solo
                  hide-details
                  v-model="formData.checkJson"
                ></v-checkbox>
              </v-col>
            </v-row>
            <v-row v-if="formData.checkJson == 'Y'">
              <v-col cols="6" md="6" class="pb-0">
                <v-label>JSON Schema</v-label>
              </v-col>
              <v-col cols="6" md="6" class="text-right pb-0" v-html="JsonSchemaCheckResult">
              </v-col>
              <v-col cols="12" md="12" no-gutters class="json-schema-view-scanner">
                <div class="CodeMirror json-color-format">
                  <ScannerViewer
                    v-model="tokenConfigs"
                    :options="this.cmOption"
                    ref="scannerFile"
                  ></ScannerViewer>
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="pr-0 pt-2">
                <v-label>{{ $t('lbl.communications.maxRetryAttempts') }}</v-label>
                <v-text-field
                  v-model="formData.maxRetry"
                  type="number"
                  solo
                  :disabled="!$auth.manage"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <dialogWindow
      ref="DuplicatePatternDialog"
      size="max"
      :detail="checkDialogInfo"
      :color="checkDialogColor"
      @select-ok="$refs.DuplicatePatternDialog.dialog = false"
    >
    </dialogWindow>
  </v-card>
</template>

<script>
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import config from '@/vue-caas/config/config.js';
import ScannerViewer from '@/vue-dlb/components/viewers/codemirror.vue';
import { getEditData } from '@/vue-caas/utils/process';

// language
import 'codemirror/mode/swift/swift.js';

// theme css
import 'codemirror/theme/rubyblue.css';

// active-line.js
import 'codemirror/addon/selection/active-line.js';

// styleSelectedText
import 'codemirror/addon/selection/mark-selection.js';
import 'codemirror/addon/search/searchcursor.js';

// highlightSelectionMatches
import 'codemirror/addon/scroll/annotatescrollbar.js';
import 'codemirror/addon/search/matchesonscrollbar.js';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/match-highlighter.js';

// keyMap
import 'codemirror/mode/clike/clike.js';
import 'codemirror/addon/edit/matchbrackets.js';
import 'codemirror/addon/comment/comment.js';
import 'codemirror/addon/dialog/dialog.js';
import 'codemirror/addon/dialog/dialog.css';
import 'codemirror/addon/search/searchcursor.js';
import 'codemirror/addon/search/search.js';
import 'codemirror/keymap/sublime.js';

// foldGutter
import 'codemirror/addon/fold/foldgutter.css';
import 'codemirror/addon/fold/brace-fold.js';
import 'codemirror/addon/fold/comment-fold.js';
import 'codemirror/addon/fold/foldcode.js';
import 'codemirror/addon/fold/foldgutter.js';
import 'codemirror/addon/fold/indent-fold.js';
import 'codemirror/addon/fold/markdown-fold.js';
import 'codemirror/addon/fold/xml-fold.js';

export default {
  components: {
    dialogWindow,
    ScannerViewer,
  },
  props: {
    item: {
      type: Object,
    },
  },

  data() {
    return {
      formData: {
        host: '',
        authToken: '',
      },
      loadFormData: {},
      formError: {
        name: {
          message: '',
        },
      },
      resourceId: '',
      path: '',
      companyId: '',
      communicationList: [],
      checkDialogColor: 'warning',
      checkDialogInfo: '',
      JsonSchemaCheckResult: '',
    };
  },

  computed: {
    cmOption() {
      if (this.$vuetify.theme.isDark == true) {
        return {
          tabSize: 4,
          lineWrapping: true,
          foldGutter: true,
          styleActiveLine: true,
          lineNumbers: true,
          line: true,
          readOnly: false,
          keyMap: 'sublime',
          mode: 'text/x-swift',
          theme: 'rubyblue',
        };
      }
      return {
        tabSize: 4,
        lineWrapping: true,
        foldGutter: true,
        styleActiveLine: true,
        lineNumbers: true,
        line: true,
        readOnly: false,
        keyMap: 'sublime',
        mode: 'text/x-swift',
        theme: 'default',
      };
    },
  },

  watch: {},

  created() {
    this.$store.dispatch('getCommunicationSelectBoxList').then((res) => {
      this.communicationList = res;
    });
    this.formData = Object.assign({}, this.getInitData(), this.item);
    this.loadFormData = Object.assign({}, this.getInitData(), this.item);

    if (this.formData.tokenConfigs) {
      this.tokenConfigs = JSON.stringify(this.formData.tokenConfigs, null, 4);
      this.formData.checkJson = 'Y';
    }
    if (this.item.action == 'add') {
      this.companyId = $cookies.get('comp-id') + '/';
      this.resourceId = config.proxyApiUrl + '/proxy/links/';
      this.path = this.companyId;
    }
    if (this.item.action != 'add') {
      this.companyId = this.formData.comm_comp_id + '/';
      if (!this.formData.path) {
        this.formData.path = '';
        this.path = this.companyId;
        this.resourceId = this.formData.host;
      } else {
        this.path = this.companyId + this.formData.path;
        this.resourceId = this.formData.host + this.path;
      }
    }
  },

  methods: {
    checkDuplicatedUri() {
      let formDataUri = this.loadFormData.host + this.companyId + this.loadFormData.path;
      this.communicationList.forEach((item) => {
        let uri = item.host + this.companyId + item.path;
        if (uri === this.resourceId && this.resourceId !== formDataUri && item.type === 'HTTP') {
          if (this.item.action == 'add') {
            this.path = this.companyId;
            this.resourceId = config.proxyApiUrl + '/proxy/links/' + this.path;
            this.formData.path = '';
          } else {
            if (!this.loadFormData.path) {
              this.formData.path = '';
              this.path = this.companyId;
              this.resourceId = this.loadFormData.host;
            } else {
              this.path = this.companyId + this.loadFormData.path;
              this.resourceId = this.loadFormData.host + this.path;
              this.formData.path = this.loadFormData.path;
            }
          }
          this.checkDialogInfo = `Duplicate URI`;
          this.$refs.DuplicatePatternDialog.dialog = true;
          return;
        }
      });
    },
    changePath(evt) {
      if (evt.target.value.substring(0, this.companyId.length) === this.companyId) {
        this.resourceId = config.proxyApiUrl + '/proxy/links/' + this.path;
        this.path = evt.target.value;
        this.formData.path = evt.target.value.substring(this.companyId.length);
      } else {
        this.path = this.companyId;
        this.resourceId = config.proxyApiUrl + '/proxy/links/' + this.path;
        this.formData.path = '';
      }
    },
    async save() {
      if (this.formData.checkJson == 'Y') {
        if (!this.tokenConfigs) {
          this.JsonSchemaCheckResult = "<v-label style='color:red'>Please input JSON</v-label>";
          return -1;
        } else {
          let check = this.checkJsonSchema();
          if (check == 'OK') {
            await this.continueSave();
          } else {
            this.JsonSchemaCheckResult = "<v-label style='color:red'>" + check + '</v-label>';
            return -1;
          }
        }
      } else {
        await this.continueSave();
      }
    },
    async continueSave() {
      let editedData = getEditData(this.formData, this.loadFormData);
      editedData.id = this.formData.id;
      if (editedData.name === undefined) {
        editedData.name = this.formData.name;
      }
      editedData.protocol = this.formData.type;
      if (this.formData.action == 'edit') {
        await this.$store.dispatch('editComm', this.formData);
        await this.sendActivate(this.formData.id, 'COM', editedData);
      } else {
        await this.$store.dispatch('insertComm', this.formData);
      }
      this.resetFormData();
    },
    async sendActivate(comId, comTp, info) {
      const params = {
        comId: comId,
        comTp: comTp,
        info: info,
      };
      await this.$store.dispatch('updateProcessInfo', params);
    },
    resetFormData() {
      if (this.item.type == 'HTTP') {
        this.formData = Object.assign({}, this.getInitData(), this.item);
        this.$refs.form.resetValidation();
      }
    },

    generateURI() {
      let d = new Date().getTime();
      this.resourceId = '/proxy/' + d;
      this.formData.host = this.resourceId;
      this.formData.resourceId = d.toString();
    },
    generateApiKey() {
      let d = new Date().getTime();
      if (window.performance && typeof window.performance.now === 'function') {
        d += performance.now();
      }
      let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        let r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3) | 0x8).toString(16);
      });
      this.formData.authToken = uuid;
    },
    getInitData() {
      return {
        name: '',
        partner: '',
        host: config.proxyApiUrl + '/proxy/links/',
        authType: 'x-api-key',
        authToken: '',
        type: 'HTTP',
        path: '',
      };
    },
    setFieldValidation(name, message) {
      this.formError[name] = {
        message,
      };
    },
    checkJsonSchema() {
      try {
        const JSON5 = require('json5');
        this.formData.tokenConfigs = JSON5.parse(this.tokenConfigs);

        if (typeof this.formData.tokenConfigs !== 'object') {
          return 'Input must be JSON';
        }

        // let Validator = require("jsonschema").Validator;
        // let v = new Validator();
        // let instance = this.formData.tokenConfigs;
        // let schema = {
        //   $schema: "https://json-schema.org/draft/2020-12/schema",
        //   $id: "https://json-schema.org/draft/2020-12/meta/core",
        //   $dynamicAnchor: "meta",

        //   title: "Core vocabulary meta-schema",
        //   type: ["object", "boolean"],
        //   properties: {
        //     $id: {
        //       $ref: "#/$defs/uriReferenceString",
        //       $comment: "Non-empty fragments not allowed.",
        //       pattern: "^[^#]*#?$",
        //     },
        //     $schema: { $ref: "#/$defs/uriString" },
        //     $ref: { $ref: "#/$defs/uriReferenceString" },
        //     $anchor: { $ref: "#/$defs/anchorString" },
        //     $dynamicRef: { $ref: "#/$defs/uriReferenceString" },
        //     $dynamicAnchor: { $ref: "#/$defs/anchorString" },
        //     $vocabulary: {
        //       type: "object",
        //       propertyNames: { $ref: "#/$defs/uriString" },
        //       additionalProperties: {
        //         type: "boolean",
        //       },
        //     },
        //     $comment: {
        //       type: "string",
        //     },
        //     $defs: {
        //       type: "object",
        //       additionalProperties: { $dynamicRef: "#meta" },
        //     },
        //   },
        //   $defs: {
        //     anchorString: {
        //       type: "string",
        //       pattern: "^[A-Za-z_][-A-Za-z0-9._]*$",
        //     },
        //     uriString: {
        //       type: "string",
        //       format: "uri",
        //     },
        //     uriReferenceString: {
        //       type: "string",
        //       format: "uri-reference",
        //     },
        //   },
        // };

        // return v.validate(instance, schema).valid;
        return 'OK';
      } catch (e) {
        console.log(e);
        let check = e.toString().split('\n');
        let err = check.find((e) => e.indexOf('JSON5') !== -1);
        if (err) {
          return err.replace('SyntaxError: JSON5: i', 'I');
        }
        return 'Invalid';
      }
    },
  },
};
</script>

<style>
.btn-window-generate {
  width: 100%;
  height: 40px !important;
  margin-top: 6px;
}
.json-schema-view-scanner .CodeMirror {
  height: 150px !important;
}
</style>
